export const APOLLO_CACHE_MAX_SIZE = 5242880;
